// <www.sharporator.com[readonly.file]> do not change the file or delete this line

import React from 'react'
    export default
        function EndpointTestingList(
        props
        )
        {
            function mainRender() {
                return (
                    <>
                        <p><span style={{marginLeft: 10}}></span><b>Testing components list</b></p>
                        <hr/>
                        <div className='table-responsive-lg'>
                            <table className='table'>
                                <thead className='table-light'>
                                    <tr>
                                        <th scope='col'><b>Component name</b></th>
                                        <th scope='col'><b>Testing endpoints</b></th>
                                        <th scope='col'><b>Caption</b></th>
                                        <th scope='col'><b>Comment</b></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><a href='current#' onClick={event => {event.preventDefault(); props.history.push('/paymentTerminalUnbinding-test')}}>PaymentTerminalUnbinding</a></td>
                                        <td>
                                            <ul>
                                                <li>
                                                    <code>/Proxy/PaymentTerminalUnbinding</code>
                                                    <br/><span style={{color: 'Gray'}}><small>Отвязать платёжный терминал от устройства</small></span>
                                                </li>
                                            </ul>
                                        </td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td><a href='current#' onClick={event => {event.preventDefault(); props.history.push('/getPaymentToken-test')}}>GetPaymentToken</a></td>
                                        <td>
                                            <ul>
                                                <li>
                                                    <code>/Proxy/GetPaymentToken</code>
                                                    <br/><span style={{color: 'Gray'}}><small>Получение платёжного токена</small></span>
                                                </li>
                                            </ul>
                                        </td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td><a href='current#' onClick={event => {event.preventDefault(); props.history.push('/closeManageBusinessDay-test')}}>CloseManageBusinessDay</a></td>
                                        <td>
                                            <ul>
                                                <li>
                                                    <code>/Proxy/CloseManageBusinessDay</code>
                                                    <br/><span style={{color: 'Gray'}}><small>Закрытие смены</small></span>
                                                </li>
                                            </ul>
                                        </td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td><a href='current#' onClick={event => {event.preventDefault(); props.history.push('/getConnectionToken-test')}}>GetConnectionToken</a></td>
                                        <td>
                                            <ul>
                                                <li>
                                                    <code>/Proxy/GetConnectionToken</code>
                                                    <br/><span style={{color: 'Gray'}}><small>Получение Token для настройки устройства</small></span>
                                                </li>
                                            </ul>
                                        </td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td><a href='current#' onClick={event => {event.preventDefault(); props.history.push('/getAuthToken-test')}}>GetAuthToken</a></td>
                                        <td>
                                            <ul>
                                                <li>
                                                    <code>/Proxy/GetAuthToken</code>
                                                    <br/><span style={{color: 'Gray'}}><small>Авторизация для получения Token</small></span>
                                                </li>
                                            </ul>
                                        </td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </>
                )
            }
            return (
                mainRender()
            )
        }
